import { useState } from 'react'

import { useRouter } from 'next/router'

import { IntroducingZen } from '~/components/zen/ZenModals'
import useTrackClick from '~/events/trackers/useTrackClick'
import { useCommonTx } from '~/hooks/useTranslationForNamespace'
import ZenIcon from '~/images/zen/ZenBlob.svg'
import { Button } from '~/ui/Button/Button'

export const ZenModeAvailable = () => {
  const router = useRouter()
  const zt = useCommonTx('zen')
  const ct = useCommonTx('common')
  const { trackCta } = useTrackClick()

  const [showZenModal, setShowZenModal] = useState(false)

  const texts = {
    learnMore: ct('learnMore'),
    availableTitle: zt('availableTitle'),
    availableDesc: zt('availableDesc'),
  }

  const onCardClick = () => {
    trackCta({
      type: 'button',
      click_name: 'home_zenmode_learn_more',
      destination: 'games',
      text: texts.learnMore,
    })
    setShowZenModal(true)
  }
  return (
    <>
      <div className='bg-zen-gradient-1 flex flex-row items-center p-6 rounded-2xl gap-3'>
        <ZenIcon title='zen' className={'w-[63px] h-[85px]'} />
        <div className='flex flex-col sm:flex-row items-start sm:items-center flex-1 gap-3'>
          <div className='flex flex-col flex-1'>
            <div className='text-body-text-2 font-semibold mb-1'>{texts.availableTitle}</div>
            <div className='text-body-text-3 text-text-subdued'>{texts.availableDesc}</div>
          </div>
          <div>
            <Button kind='primary' size='none' className='px-5 py-2 uppercase font-normal' onClick={onCardClick}>
              {texts.learnMore}
            </Button>
          </div>
        </div>
      </div>
      {showZenModal && (
        <IntroducingZen
          onClose={() => setShowZenModal(false)}
          onPlayInZenMode={() => {
            router.push('/games')
            setShowZenModal(false)
          }}
        />
      )}
    </>
  )
}
